import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='container'>
        <div className='footer__inner'>
          <span className='footer__logo'>
            Mike Tsai Photography {/* ← swap your name here */}
          </span>

          <nav className='footer__links' aria-label='Footer navigation'>
            <Link to='/portraits' className='footer__link'>Portraits</Link>
            <Link to='/events'    className='footer__link'>Events</Link>
            <Link to='/nature'    className='footer__link'>Nature</Link>
            <Link to='/about'     className='footer__link'>About</Link>
            <Link to='/contact'   className='footer__link'>Contact</Link>
          </nav>

          <p className='footer__copy'>
            © {year} Mike Tsai Photography {/* ← swap your name */}
          </p>
        </div>
      </div>
    </footer>
  );
}
